import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/AnalyticsService';
import { EventRepository } from '~repositories/EventRepository';
import { Event } from '~entities/Event';
import { LoyaltyEventAction } from '~constants/Loyalty';

export class LoyaltyRewardsUseCase {
    private eventRepository: EventRepository;
    private loyaltyPayloadData: string;
    private loyaltyRewardsEventData: string;

    constructor(loyaltyPayloadData: string, loyaltyRewardsEventData: string) {
        this.eventRepository = diContainer.get(serviceNames.eventRepository);
        this.loyaltyPayloadData = loyaltyPayloadData;
        this.loyaltyRewardsEventData = loyaltyRewardsEventData;
    }

    public execute() {
        const newEvent = new Event({
            id: this.eventRepository.generateId(),
            name: this.loyaltyRewardsEventData,
            type: 'link',
            payload: this.getAccountLoyaltyRewardsInfoPayload()
        });
        this.eventRepository.addEventToQueue(newEvent);
    }

    private getAccountLoyaltyRewardsInfoPayload() {
        return {
            event_name: LoyaltyEventAction.LOYALTY_EVENT_PAGE,
            event_category: LoyaltyEventAction.LOYALTY_EVENT_PAGE,
            event_action: LoyaltyEventAction.LOYALTY_REWARDS_TEXT,
            event_label: this.loyaltyPayloadData
        };
    }
}
